import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AsyncReduxState, initialAsyncReduxState } from '../../../redux/@config/AsyncReduxState'
import { TransportationOption } from '../../entities/TransportationOption/TransportationOption'

export type TransportationOptionsState = AsyncReduxState<{
    transportationOptions: TransportationOption[];
}>;

const initialState: TransportationOptionsState = {
    ...initialAsyncReduxState,
    transportationOptions: [],
}

export const TransportationOptionsSlice = createSlice({
    name: 'transportationOptionsReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): TransportationOptionsState {
            return {
                ...state,
                isLoading: action.payload,
            }
        },
        setError(state, action: PayloadAction<string>): TransportationOptionsState {
            return {
                ...state,
                error: action.payload,
            }
        },
        setTransportationOptions(state, action: PayloadAction<TransportationOption[]>): TransportationOptionsState {
            return {
                ...state,
                transportationOptions: action.payload,
            }
        },
    },
})

export const {
    setIsLoading,
    setError,
    setTransportationOptions,
} = TransportationOptionsSlice.actions

export default TransportationOptionsSlice.reducer
